import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-subscription',
  templateUrl: './manage-subscription.component.html',
  styleUrls: ['./manage-subscription.component.css']
})
export class ManageSubscriptionComponent implements OnInit {
  public manageSubscriptionForm: FormGroup;
  public loading = false;
  public activeClass = 'active';
  public subscriberOptions:any={};
  expiryMonths: Array<any> = [
    { value: "", viewValue: "Month" },
    { value: "1", viewValue: "1" },
    { value: "2", viewValue: "2" },
    { value: "3", viewValue: "3" },
    { value: "4", viewValue: "4" },
    { value: "5", viewValue: "5" },
    { value: "6", viewValue: "6" },
    { value: "7", viewValue: "7" },
    { value: "8", viewValue: "8" },
    { value: "9", viewValue: "9" },
    { value: "10", viewValue: "10" },
    { value: "11", viewValue: "11" },
    { value: "12", viewValue: "12" }
  ];

  expiryYears: Array<any> = [
    { value: "", viewValue: "Year" },
  ];

  constructor(private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService,
    private router: Router
  ) {
    this.manageSubscriptionForm = formBuilder.group({
      card_number: [null, Validators.required],
      expiry_month: [null, Validators.required],
      expiry_year: [null, Validators.required],
      card_cvv: [null, Validators.required]

    });

    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetails && userDetails.reinstate_old_plan) {
    } else {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.getExpiryYears();
  }

  isFieldValid(field: string) {
    return (
      !this.manageSubscriptionForm.get(field).valid &&
      this.manageSubscriptionForm.get(field).touched
    );
  }

  getExpiryYears() {
    var date = new Date();
    for (let currentYear = 0; currentYear < 10; currentYear++) {
      this.expiryYears.push(
        {
          value: date.getFullYear() + currentYear,
          viewValue: date.getFullYear() + currentYear
        });

    }
  }

  manageCardData = function (postData) {
    this.loading = true;
    if (this.manageSubscriptionForm.valid) {
      this.subscriberOptions = {   
        id: localStorage.getItem("userID"),
        card_number: postData.card_number,
        card_expiry_month: postData.expiry_month,
        card_expiry_year:postData.expiry_year,
        card_cvv: postData.card_cvv
      };
     

      this.CommonService.apiService(
        "POST",
        "update/card",
        this.subscriberOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) { 
            this.manageSubscriptionForm.reset();
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            }); 
            this.router.navigate(["/login"]);           
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-danger",
            timeout: 5000
          });
        }
      );

    }
    else {
      this.loading = false;
      this.validateAllFormFields(this.manageSubscriptionForm);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/manage-subscription/manage-subscription.component.ts